import { Component, OnInit, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { IngTextArea } from '../../inputs';

@Component({
  selector: 'ing-text-area',
  templateUrl: './text-area.component.html',
  styleUrls: ['./text-area.component.scss']
})
export class TextAreaComponent implements OnInit {
  @Input() form:  FormGroup;
  @Input() input: IngTextArea;

  constructor() { }

  ngOnInit() {
    this.input.controlType = 'ing-textarea';
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/ing-dynamic-form/dynamic-form/text-area/text-area.component.ts